<template>
	<div>
		<div class="modle">
			<div class="content modle-box">
				<div class="describe">
					<div class="line-1">不爽约，速必达</div>
					<div class="line-2"></div>
					<div class="line-3">NEVER BREAK, SPEED SERVICE</div>
					<div class="line-4">淘速取专注于校园免费代取快递服务，大学生可以通过APP免费代取，同时淘速取APP提供了淘宝.天猫等大型电商平台多种产品，从源头完成大学生购买到取件的一站式服务。</div>
				</div>
				<img src="../image/phone1.png" style="width: 190px;height: 357px;" />
			</div>
		</div>


		<div class="modle" style="background-color: #f6f6f6;">
			<div class="content modle-box">
				<img src="../image/phone2.png" style="width: 190px;height: 357px;" />
				<div class="describe">
					<div class="line-1">代取订单</div>
					<div class="line-2"></div>
					<div class="line-3">Order collection</div>
					<div class="line-4">
						在淘速取APP下单，即可获取代取码；查码可查看自己的代取码，包括未使用、已使用，并能查看获取时间以及使用时间；在代取页面中填写详细信息提交订单就可以免费代取快递，通过特有的产品模式解决校内大学生取快递时间集中、排队长的问题，可以真正做到将快递从校内驿站免费送到学生手里。
					</div>
				</div>
			</div>
		</div>

		<div class="features">
			<div class="content modle-box">
				<div class="describe">
					<div class="line-1">APP特色</div>
					<div class="line-2"></div>
				</div>
				<div class="item-box" style="width: 900px;">
					<div class="item">
						<div class="img-box">
							<img src="../image/shouye_kuaidi@2x.png" />
						</div>
						<div class="text-box">
							<div style="font-weight: bold;color: #333333;font-size: 22px;margin-bottom: 20px;">免费代取快递</div>
							<div style="font-weight: bold;color: #888888;font-size: 15px;">用户可在APP内下单免费代取快递</div>
						</div>
					</div>
					<div class="item">
						<div class="img-box">
							<img src="../image/shouye_gouwu@2x.png" />
						</div>
						<div class="text-box">
							<div style="font-weight: bold;color: #333333;font-size: 22px;margin-bottom: 20px;">购物</div>
							<div style="font-weight: bold;color: #888888;font-size: 15px;">提供多平台商品</div>
						</div>
					</div>
					<div class="item">
						<div class="img-box">
							<img src="../image/shouye_youhui@2x.png" />
						</div>
						<div class="text-box">
							<div style="font-weight: bold;color: #333333;font-size: 22px;margin-bottom: 20px;">优惠劵</div>
							<div style="font-weight: bold;color: #888888;font-size: 15px;">包含多种优惠券享受超低价格</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="appImg" style="background-color: #f6f6f6;">
			<div class="content appImg-box">
				<img src="../image/shouye_meiri@2x.png" />
				<img src="../image/shouye_jishi@2x.png" />
				<img src="../image/shouye_daiqu@2x.png" />
				<img src="../image/shouye_jifen@2x.png" />
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {

			}
		},
		mounted() {
			// hideLoading()
		},
		methods: {}
	}
</script>

<style lang="less">
	.modle {
		width: 100%;
		height: 480px;

		.modle-box {
			height: 480px;
			display: flex;
			justify-content: space-between;
			align-items: center;

			.describe {
				margin-bottom: 50px;
			}

			.line-1 {
				font-size: 24px;
				font-weight: bold;
				color: #333333;
				margin-bottom: 5px;
			}

			.line-2 {
				width: 46px;
				height: 5px;
				border-radius: 3px;
				background-color: #f03E2E;
				margin-bottom: 10px;
			}

			.line-3 {
				font-size: 14px;
				color: #A0A0A0;
				margin-bottom: 10px;
			}

			.line-4 {
				width: 578px;
				font-size: 18px;
				color: #888888;
			}
		}
	}

	.features {
		width: 100%;
		height: 480px;

		.modle-box {
			height: 480px;
			display: flex;
			justify-content: center;
			align-items: center;
			flex-direction: column;

			.describe {
				margin-bottom: 30px;
				display: flex;
				flex-direction: column;
				align-items: center;

				.line-1 {
					font-size: 24px;
					font-weight: bold;
					color: #333333;
					margin-bottom: 5px;
				}

				.line-2 {
					width: 115px;
					height: 5px;
					border-radius: 3px;
					background-color: #f03E2E;
					margin-bottom: 10px;
				}
			}

			.item-box {
				display: flex;
				justify-content: space-between;
				width: 1000px;

				.item {
					width: 240px;
					height: 326px;
					background-color: #f6f6f6;
					box-shadow: 3px 6px 35px 0px rgba(4, 0, 0, 0.11);

					.img-box {
						width: 100%;
						height: 196px;
						background-color: #FFFFFF;
						display: flex;
						justify-content: center;
						align-items: center;

						img {
							width: 88px;
							height: 88px;
						}

					}

					.text-box {
						height: 130px;
						display: flex;
						flex-direction: column;
						align-items: center;
						justify-content: center;
					}
				}
			}


		}
	}

	.appImg {
		width: 100%;
		height: 480px;

		.appImg-box {
			height: 480px;
			display: flex;
			justify-content: space-between;
			align-items: center;

			img {
				width: 265px;
				height: 443px;
			}
		}
	}

	.content {
		width: 1200px;
		height: 128px;
		// background-color: #FF0000;
		margin: 0 auto;
	}
</style>
